$(function(){
  cartJSEvent();
  masterPromo(false);
  calculateProgress();
  calculateProgressGWP();
 // collectionSortBy();
  if (location.href.includes('/products')) {
    initFlickityImageGallery();
    onloadSiblingsProducts();
    onloadPDPbutton();
  }
  if (location.href.includes('/collection')) {
    stickyFilter();
  }
  initAnnouncementSlider();
  initLogoListSlider();
  //sessionStorage.removeItem("FreeGift");
  
});

//start: hover grid
jscHoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-prev-arrow').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-next-arrow').removeClass('d-none');
    
  }
}
jscOuthoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-prev-arrow').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-next-arrow').addClass('d-none');
    
  }
}
//end: hover grid

//start: shorten product title
onloadShortenProdTitle = () => {
  if ($(window).width() < 380) {
    var maxCharacters = 16;
  }
  else if ($(window).width() < 480) {
    var maxCharacters = 23;
  }
   else if ($(window).width() < 798) {
    var maxCharacters = 42;
   }
   else if ($(window).width() < 1025) {
    var maxCharacters = 24;
   }
   else if ($(window).width() > 1026) {
    var maxCharacters = 38;
   } else {
    var maxCharacters = 30;
  }
  
  $(document).ready(function() {
    $(".product__grid-item").each(function() {
      var productTitle = $(this).find(".product-thumbnail__title");
      var originalText = productTitle.text();
  
      var maxTitleWidth = $(this).width(); // Get the grid container width
      var fontSize = parseFloat(productTitle.css("font-size"));
      // var maxCharacters = Math.floor(maxTitleWidth / fontSize);
      // var maxCharacters = Math.floor(maxTitleWidth / 10);
      
      console.log(maxTitleWidth,fontSize,maxCharacters);
      if (originalText.length > maxCharacters) {
        var truncatedText = originalText.substring(0, maxCharacters) + "...";
        productTitle.text(truncatedText);
      }
    });
  });
}
//end: shorten product title

//start: collection filter
jscShowDrawer = (e) => {
  $('.jsc-filter-drawer-container').addClass('show-drawer');  
  $('html').addClass('drawer-open');
  
}
jscHideDrawer = (e) => {
  $('.jsc-filter-drawer-container').removeClass('show-drawer');
  $('html').removeClass('drawer-open');
}
//end: collection filter

//start: change grid layout in mobile
jscMobileGridLayout = (e,grid) => {

  var grids = $(e).parents('.collection-main').find('.collection__content .product__grid-item');

  if (grid == 'layout-switch--one-column') {
    grids.removeClass('small-down--one-half');
    grids.addClass('small-down--one-whole');
    // console.log('show 1 grids');
  }
  else if (grid == 'layout-switch--two-columns') {
    grids.addClass('small-down--one-half');
    grids.removeClass('small-down--one-whole');
    // console.log('show 2 grids');
  } else {

  }

  $(e).addClass('layout-switch--active');
  $(e).siblings('.layout-switch').removeClass('layout-switch--active');
   
}
//end: change grid layout in mobile

//start: to change the Sort By dropdown width
collectionSortBy = () => {
  // console.log('find dropdown',$("#sort-by").length);
  var url = window.location.href;
  console.log('url',url);
  var dropdown_width = $('#sort-by option:selected').width();
  console.log('current dropdown width',dropdown_width,'hidden dropdown width',$("#width_tmp_select").width());
  
  setTimeout(function(){
    
    
  }),3000;
  // $('#sort-by').width($("#width_tmp_select").width() + 15);
  // $(document).ready(function() {
  //   $("#width_tmp_option").html($('#sort-by option:selected').text());
  //   $('#sort-by').width($("#width_tmp_select").width());

  //   $('#sort-by').change(function(){
  //     $("#width_tmp_option").html($('#sort-by option:selected').text());
  //     $(this).width($("#width_tmp_select").width() + 15);
  //     console.log('click here');
  //   });
  // });
}
//end: to change the Sort By dropdown width

//start: update pdp ATC button
onloadPDPbutton = () => {
  var $oosBtn = $('.jsc-pdp-atc-btn-container.jsc-oos-button');
  var $oosBtnInner = $('.jsc-pdp-atc-btn-container.jsc-oos-button .button--add-to-cart');
  if ($oosBtn.length > 0) {
    $('.jsc-pdp-atc-btn-container.jsc-oos-button .button--add-to-cart .text').text('Notify Me');
    console.log('variant oos');

    var timer = setInterval(function() {
      var $wishlistBtn = $('.jsc-pdp-atc-btn-container .swym-button-bar');
      var $klaviyoBtn = $('.jsc-pdp-atc-btn-container .klaviyo-bis-trigger')
  
      if ($wishlistBtn.length > 0) {
        if ($klaviyoBtn.length > 0 ) {
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').css({
            'display': 'block'
          });
          // setTimeout(function(){
            $oosBtnInner.css({
              // 'color': 'transparent',
              'position': 'absolute',
              'z-index': '-1'
            });
          // },100);
          
          clearInterval(timer);
        }
      }
    })
  }
  
}
//end: update pdp ATC button

//start: to update button style in PDP
jscSelectVariant = (e,size,var_avail,var_id) => {
  // var $label = $(e).parents('.variant-wrapper').find('.jsc-pdp-size');
  // $label.find('.jsc-selected-variant').text(size);
  console.log(size,var_avail,var_id);

  if (var_avail == 'true') {
    $('.jsc-pdp-atc-btn-container').removeClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container').find('.jsc-atc-text').text('Add to cart');
    $('.jsc-pdp-atc-btn-container .button--add-to-cart').css({
      'position': 'relative',
      'z-index': 'auto'
    });
  } else {
    $('.jsc-pdp-atc-btn-container').addClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container').find('.jsc-atc-text').text('Notify Me');
    $('.jsc-pdp-atc-btn-container.jsc-oos-button .button--add-to-cart').css({
      'position': 'absolute',
      'z-index': '-1'
    });
    $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
  }

  //start: price snippet
  var variant_info = $('.jsc-all-variants-info');

  if (variant_info.length > 0) {
    variant_info.children().each(function(){
      var $varID = $(this).attr('data-var-id');

      if ($varID == var_id) {
        $(this).removeClass('d-none');
        $(this).addClass('d-flex');
      } else {
        $(this).addClass('d-none');
        $(this).removeClass('d-flex');
      }
      
    });
  }
  //end: price snippet
}
//end: to update button style in PDP

//start: initiate flickity for image gallery in pdp
initFlickityImageGallery = () => {
  var $newGallery = $('.jsc-product-gallery__main').length;

  if ($(window).width() < 798) {
    if ($newGallery > 0) {
      console.log('init flickity in mobile');
      $('.jsc-product-gallery__main').flickity({
        // options
        prevNextButtons : false,
        pageDots : true,
        wrapAround : true,
        contain: true,
        cellAlign: 'left',
        draggable: true,
        imagesLoaded : true,
        on: {
          ready: function() {
            $(this.element).addClass('jsc-flickity-initiated');
          }
        }
      });
    }
  }

  // setTimeout(function(){
  //   var $gallery = $('.jsc-product-gallery__main.flickity-enabled').length;
  //   console.log('default flick image gallery',$gallery,$(window).width());
  // },1500);
  
}
//end: initiate flickity for image gallery in pdp

//start: color siblings feature in pdp
onloadSiblingsProducts = () => {
  var $prod_details = $('.jsc-prod-json-details').find('.jsc-each-prod-json');
  var $prod_sibs_container = $('.jsc-sibling-products-content');
  var $prod_sibs_grid = $prod_sibs_container.find('.jsc-each-colour-url');
  var $current_url = window.location.href;

  $prod_details.each(function(){
    var $this_graphql = $(this).attr('data-graphql');
    
        // Define your GraphQL query
        const graphqlQuery = `
        query {
          product(id: "` + $this_graphql + `") {
            id
            title
            handle
            variants(first: 10) {
              edges {
                node {
                  title
                }
              }
            }
            featuredImage {
              id
              src
            }
          }
        }
        `;
        
        // Set the endpoint URL
        const endpointUrl = 'https://edgeclothing.myshopify.com/api/2023-10/graphql.json';

        // Send the GraphQL request using jQuery
        $.ajax({
          url: endpointUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '21eb93fc41c98da6f7c14eb991237105' , 
          },
          data: JSON.stringify({ query: graphqlQuery }),
          success: function(response) {
            // Handle the response here
            console.log('Result',response);
            var prod_title = response.data.product.title;
            var prod_handle = response.data.product.handle;
            var prod_img = response.data.product.featuredImage.src;
            var prod_url = '/products/' + prod_handle;
            var variant_title = response.data.product.variants.edges[0].node.title;
            var variant_color = variant_title.split(" / ");
            var type_tab;
            var var_color = '';

            if (variant_color[0] !== undefined ) {
              var_color = variant_color[0];
            } else {
              var_color = '';
            }
            var color_handle = var_color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

            if ($current_url.includes(color_handle) && var_color != '') {
              type_tab = 'jsc-active-col';
            } else {
              type_tab = 'jsc-inactive-col';
            }
            
            var $color_grid = '<a href="' + prod_url + '" class="jsc-each-colour-url"><div class="jsc-each-colour-prod ' + type_tab + '"><img class="jsc-each-colour-prod-img" src="' + prod_img + '" alt="' + prod_title +'"></div><span>' + var_color + '</span></a>';

            $prod_sibs_grid.each(function(){
              var $thisGraphql = $(this).attr('data-graphql');
              var $thisUrl;
              var $thisColor = $(this).find('span');
              var $thisColorImg = $(this).find('.jsc-each-colour-prod-img');             

              if ($thisGraphql == $this_graphql) {
                $thisUrl = $(this).attr("href",prod_url);
                $thisColor.text(var_color);
                $thisColorImg.attr("src",prod_img);
                $thisColorImg.attr("alt",prod_title);
                
                $(this).addClass(type_tab);
                $(this).removeClass('d-none');
                
              }
            });
          },
          error: function(error) {
            // Handle any errors here
            console.error('Error!',error);
          }
        });
  });

}
//end: color siblings feature in pdp

//start: make collection filter sticky when scrolling
stickyFilter = () => {
  
  $(window).scroll(function() {
    var $stickynav = $('.header-sticky-wrapper').length;
    // console.log('$stickynav',$stickynav,$(document).scrollTop());

    if ($(document).scrollTop() > 80) {

      if ($stickynav > 0) {
        // if the menu nav is sticky, make the collection filter sticky after the menu nav
        $(".jsc-collection-header-section").addClass("jsc-filter-sticky");
      } else { 
        // if the menu nav is not sticky, make the collection filter stick to top
        $(".jsc-collection-header-section").addClass("jsc-filter-sticky-top");
      }
      
      // console.log('sticky collection filter');
    } else {
      $(".jsc-collection-header-section").removeClass("jsc-filter-sticky-top");
      $(".jsc-collection-header-section").removeClass("jsc-filter-sticky");
      // console.log('unstick collection filter');
    }
  });
}

//start: pdp size guide popup
jscDisablePageScroll = (e,check) => {

  if (check == 'true') {
    $(e).parents('body').addClass('modal-open');
  } else {
    $(e).parents('body').removeClass('modal-open');
  }
  
}
//end: pdp size guide popup

//start: open first level nav as slider
jscOpenMenu = (e,title) => {
  var $selectedNav = $(e).parents('.mobile-menu__list-item');
  $selectedNav.addClass('menu-opening');

  // console.log('open',title);
  
}
jscCloseMenu = (e,title) => {
  var $selectedNav = $(e).parents('.mobile-menu__list-item');

  setTimeout(function(){
    $selectedNav.find('.close-dropdown').trigger( "click" );
    $selectedNav.removeClass('menu-opening');
  },200);
  
}
//end: open first level nav as slider

//start: zoom image when click on the zoom icon
zoomImagePdp = (e) => {
  
  if ($(window).width() > 799) {
    var $imgGallery = $(e).siblings('.jsc-product-gallery__main').find('.product-gallery__image');
    var $imgFirst = $imgGallery.first(); //get only the first image for desktop

  } else {
    var $imgFirst = $(e).siblings('.jsc-product-gallery__main').find('.product-gallery__image.is-selected'); // get the active image for mobile

  }
  // console.log('$imgFirst',$imgFirst);

  $imgFirst.find('.product-gallery__link').click(); //click only the first image for desktop. click on the active image for mobile
  
}
//end: zoom image when click on the zoom icon

// START Free shipping delivery
// Calculate the progress number, and the width of the progress bar.
function calculateProgress(currentVal, targetVal) {

  var freeDeliverySection = $('.jsc-cart-freedelivery__wrapper')
  var cartMinText = freeDeliverySection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = $('.cart-shippingThreshold__progress');
  var progressNum = $('.cart-shipping__num');
  var progressOuter = $('.cart-shipping__numOuter');
  var successMsg = $('.cart-shipping__success');


  $.when($.getJSON('/cart.js', function(cart) {
    var _totalPrice = cart.total_price;
    
    if (_totalPrice > 0) {
      $('.jsc-cart-freedelivery__wrapper').removeClass('d-none');
      var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
      var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
      if (progressWidth >= 100) {
        progressWidth = 100;
      }
      var progressWidthPercent = progressWidth.toString() + '%';
      console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

      progressBar.each(function(){
        
        $(this).css({
          width: progressWidthPercent
        });
      });

      if (_totalPrice >= cartMinVal) {
        console.log('free delivery');
        progressOuter.hide();
        successMsg.show();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      } else {
        console.log('still short from free delivery',calcFreeDeliveryVal);
        progressNum.text(calcFreeDeliveryVal);
        progressOuter.show();
        successMsg.hide();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      }
    }
    else{
      console.log('cart Total',_totalPrice);
      $('.jsc-cart-freedelivery__wrapper').addClass('d-none');
    }
    
  })).then(function() {
    
  });

};

// In your theme's main JS file, find each ajax call where your store adds to, deletes from, and updates the cart. Put this in the success function of each. 
// NOTE: If you make this ajax request outside of the functions that update the cart, the calculator won't sync with the current cart state without refreshing the page. You need to specify that you want to read the current cart data AFTER the new items are added/removed.
 fetch('/cart.js')
.then(response => response.json())
.then(data => {
  var _sgMinPrice = parseInt($('.cart-shipping__wrapper').attr('minprice-sgd'));
  calculateProgress(data.total_price, _sgMinPrice);
});

jscRecalculateProgress = () => {
  setTimeout(function(){
    calculateProgress();
    // console.log('recalculate');
  },500);
}
// END Free shipping delivery

//start: close cart drawer
jscCloseCartDrawer = () => {
  $('.ajax-cart__close-icon').click();
}
//end: close cart drawer

// start: announcement bar slider
initAnnouncementSlider = () => {
  var slider = $('.announcement-bar__container .announcement-bar__content');
  var isAutoplay = $(slider).attr('data-is-autoplay');
  var duration = parseInt($(slider).attr('data-duration')) * 1000;

  if(isAutoplay == 'true') {
    $(slider).flickity({
      prevNextButtons : false,
      pageDots : false,
      wrapAround : true,
      contain: true,
      cellAlign: 'center',
      draggable: true,
      autoPlay: duration,
      pauseAutoPlayOnHover: true
    });
  }
  else {
    $(slider).flickity({
      prevNextButtons : false,
      pageDots : false,
      wrapAround : true,
      contain: true,
      cellAlign: 'center',
      draggable: true
    });
  }
}
// end: announcement bar slider

// start: logo list slider
initLogoListSlider = () => {
  var slider = $('.jsc-scrollable-logo-section .logo_slider');
  var duration = 2500;
  
  var slider_number = $('.jsc-scrollable-logo-section').attr('data-grid-number');
  //var group_cells = parseInt(slider_number);
  

  if($(window).width() < 798 ) {
    //group_cells = 2;
  }
  else if ($(window).width() < 480 ) {

  }

  if ($('.jsc-scrollable-logo-section').length > 0) {
    $(slider).flickity({
      prevNextButtons : true,
      pageDots : false,
      wrapAround : true,
      contain: true,
      cellAlign: 'left',
      draggable: true,
      autoPlay: duration,
      pauseAutoPlayOnHover: false
    });
  }

}
// end: logo list slider

jscRedirectToCart = () => {
  cartUrl = '/cart';
  window.location.href = cartUrl;
}

//Start CartJS Function
cartJSEvent = () => {
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart updated');
    if (location.href.includes('/cart')){
      location.reload();
    }
    document.documentElement.dispatchEvent(
    new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
    $('.jsc-page-loading').remove();
    var varID = $('.variant-selection').attr('variant');
    //jscUpdateCartDrawer(varID);
  });
  $(document).on('cart.requestStarted', function(event, cart) {
    if (location.href.includes('/cart')) {
      var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-loading-text">Updating your cart...</div>
                  </div>
                </div>`;
      $('body').prepend($html);
    }
    console.log('updating cart');
  });
}

cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {

      if (location.href.includes('/cart')) {
        //reload only the product details section in cart page
        //console.log('data.item_count',data.item_count);
        
        if (!data.item_count) { // if cart is empty do this
          $(".jsc-cart-container").load(location.href+" .jsc-cart-container>*","");
          // console.log('reload empty cart section');
        }
      }
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}
//End CartJS Function

//Start Master Promo Function
masterPromo = (isDrawer) =>{
  // setTimeout(function(){
  // },1000);
  cartGift();
}

//Start GWP based on cart, product or collection promo
cartGift = () =>{
  addCartGift();
  removeCartGift();
}

addCartGift = () =>{
  var $elem = $('.jsc-cart-gift');
  $elem.each(function(){
  var $vid = parseInt($(this).val());
  var $obj = {};
  var $promoNo = $(this).attr('data-promo');
  var removeGift = sessionStorage.getItem("FreeGift");

  $obj['_Cart_Gift'] = $promoNo;
  $obj['_Cart_GWP'] = 'Free Gift';
  if ($elem.length > 0) {
    if (removeGift != 'Remove') {
      cartJSAddQuery($vid,1,$obj,true);
    }
  }
  });
}

removeCartGift = () =>{
  var $elem = $('.jsc-cart-gift-remove');
  $elem.each(function(){
  var $key = parseInt($(this).val());

  if ($elem.length > 0) {
    cartJSUpdateQuery($key, 0, {}, true);
  }
  });
}

removeFreeGift = (e,varID) =>{
  // this function is used to remove gwp item in cart using sessionStorare. the gwp can only be re-added when browser is restarted
  sessionStorage.setItem("FreeGift", "Remove");
  //console.log(varID);
  cartJSUpdateQuery(varID, 0);
}
//End GWP based on cart, product or collection promo

//start: pdp atc
jscClickATC = () => {
  var pageUrl = window.location.href;
  var varID = pageUrl.split('variant=')[1];
  jscUpdateCartDrawer(varID);
  setTimeout(function(){
    jscOpenCartDrawer();
  },500);
}
jscCustomATC = (e) => {
  var varID = $('.variant-selection').attr('variant');
  jscUpdateCartDrawer(varID);
  setTimeout(function(){
    jscOpenCartDrawer();
  },500);
  //console.log('add123 varID',varID);
  cartJSAddQuery(varID,1,{},true);
}
//end 

//start: side cart drawer
jscOpenCartDrawer = () => {
  $('.jsc-cart-drawer-div').addClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').removeClass('d-none');

  //start: close drawer when clicked outside
  $('.jsc-cart-drawer-overlay').click(function(){
    jscCloseCartDrawer();
  });
  //end: close drawer when clicked outside
}
jscCloseCartDrawer = () => {
  $('.jsc-cart-drawer-div').removeClass('open-cart-drawer');
  $('.jsc-cart-drawer-overlay').addClass('d-none');
}
jscUpdateCartDrawer = (varID,isGwpInCart) => {
  console.log('update cart drawer');
  setTimeout(function(){
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      var $cartItems = data.items;
      var $cartDrawerItems = $('.jsc-cart-items-section')

      console.log('isGwpInCart from update drawer',isGwpInCart);
      if (isGwpInCart == true) {
        var freeItemID = parseInt($('.jsc-cart-gift-remove.jsc-promo-1').val());
        console.log('freeItemId',freeItemID);
        $cartDrawerItems.children().each(function(){
          var $thisID = $(this).attr('data-var-id');
          if ($thisID == freeItemID) {
            $(this).remove();
          }
        });
      }

      var _sgMinPrice = parseInt($('.jsc-cart-freedelivery-section .cart-shipping__wrapper').attr('minprice-aud'));
      var _gwpMinPrice = parseInt($('.jsc-cart-freegift-section .cart-shipping__wrapper').attr('minprice-aud'));
      calculateProgress(data.total_price, _sgMinPrice);
      calculateProgressGWP(data.total_price, _gwpMinPrice);

      //start: update cart drawer header
      var $drawerHeader = $('.jsc-cart-drawer-header');
      $drawerHeader.find('.cart-link__count').html(data.item_count);
      $drawerHeader.find('.cart-drawer-qty').html(data.item_count);
      $('.header-cart').find('.cart-link__count').html(data.item_count); //nav cart icon
      //end: update cart drawer header

      //start: update cart drawer content
        for (var i = 0; i < $cartItems.length; i++) {
          var $itemID = $cartItems[i].id;
          var $itemQty = $cartItems[i].quantity;
          var $itemProdTitle = $cartItems[i].product_title;
          var $itemVarOpt = $cartItems[i].options_with_values;
          var $itemUrl = $cartItems[i].url;
          var $itemImage = $cartItems[i].featured_image.url;
          var $itemImageAlt = $cartItems[i].featured_image.alt;
          var $itemPrice = $cartItems[i].original_price;
          var $itemPriceDiscounted = $cartItems[i].discounted_price;
          var $isItemInDrawer = false;
          var $itemKey = $cartItems[i].key;
          //console.log('$itemID',$itemID);
  
          $cartDrawerItems.children().each(function(){
            var $thisID = $(this).attr('data-var-id');
  
            if ($thisID == $itemID) {
              
              $isItemInDrawer = true;
              if (varID == $thisID) { //update the content of matching variant ID
                console.log('update qty of',$itemID);
                $(this).find('.cart-item__quantity-input').attr('value',$itemQty);
                $(this).find('.minus').removeClass('unusable');
              }
            }
            
          });
          //console.log('$isItemInDrawer',$isItemInDrawer,$itemID);
          if ($isItemInDrawer == true) {
            jscOpenCartDrawer();
          } else {
            //if item is not in cart drawer yet, build the grid
            jscCreateCartGrid($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,$itemPriceDiscounted,isGwpInCart,$itemKey)
          }
        }
      //end: update cart drawer content

      //start: update cart drawer footer
      var $drawerFooter = $('.jsc-cart-drawer-footer');
      var format_CartPrice = Shopify.formatMoney(data.total_price, $('body').data('money'));
      var currency_CartPrice = format_CartPrice.replace('undefined','$');
      $drawerFooter.find('.jsc-cart-drawer-total').html(currency_CartPrice);
      //end: update cart drawer footer
    });
    //document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  },500);
  
}
jscCreateCartGrid = ($itemID,$itemQty,$itemProdTitle,$itemVarOpt,$itemUrl,$itemImage,$itemImageAlt,$itemPrice,$itemPriceDiscounted,isGwpInCart,$itemKey) => {
  //console.log($itemID,$itemPriceDiscounted,$itemPrice);
  var format_varPrice = Shopify.formatMoney($itemPrice, $('body').data('money'));
  var currency_varPrice = format_varPrice.replace('undefined','$');
  var format_varPriceDisc = Shopify.formatMoney($itemPriceDiscounted, $('body').data('money'));
  var currency_varPriceDisc = format_varPriceDisc.replace('undefined','$');
  var $cloneGrid = $('.jsc-cart-items-section').find('.jsc-dummy-cart-line-items.jsc-cart-line-items').first().clone();
  var $getVarDetails = $('.jsc-product-variant-details');
  var $thisMaxQty;

  $getVarDetails.children().each(function(){
    var $thisID = $(this).attr('data-var-id');
    if ($itemID == $thisID) {
      $thisMaxQty = $(this).attr('data-max-qty');
      $cloneGrid.find('.jsc-product-details-input').attr('data-max-qty',$thisMaxQty);
      if ($thisMaxQty <= 1) {
        $cloneGrid.find('.jsc-qty-selector .plus').addClass('unusable');
      }
    }
  });

  $cloneGrid.find('.cart-line-item-img a').attr('href',$itemUrl);
  $cloneGrid.find('.cart-line-item-img img').attr('src',$itemImage);
  $cloneGrid.find('.cart-line-item-img img').attr('alt',$itemImageAlt);
  $cloneGrid.find('.cart-line-item-prod-title a').text($itemProdTitle);
  $cloneGrid.attr('data-var-id',$itemID);
  $cloneGrid.attr('data-key',$itemKey);
  $cloneGrid.attr('data-gwp','false');
  $cloneGrid.find('.cart-line-item-var-title').remove();
  $cloneGrid.find('.jsc-qty-selector input').attr('value',$itemQty);
  $cloneGrid.find('.jsc-qty-selector .quantity-down').addClass('unusable');
  if (isGwpInCart == false) {
    $cloneGrid.find('.jsc-qty-selector .quantity').remove();
    $cloneGrid.find('.jsc-qty-selector').addClass('jsc-cart-drawer-free-gift-label')
    $cloneGrid.find('.jsc-qty-selector').append('<span class="jsc-cart-drawer-free-gift-span">FREE GIFT</span>');
    $cloneGrid.attr('data-gwp','true');
  }

  if ($itemPriceDiscounted < $itemPrice) {
      //use Sale styling
      $cloneGrid.find('.cart-line-item-price .jsc-struck-out-price').removeClass('d-none');
      $cloneGrid.find('.cart-line-item-price .jsc-struck-out-price .theme-money').text(currency_varPrice);
      $cloneGrid.find('.cart-line-item-price .jsc-variant-price').addClass('jsc-sale-price');
      $cloneGrid.find('.cart-line-item-price .jsc-variant-price .theme-money').text(currency_varPriceDisc);
  } else {
    $cloneGrid.find('.cart-line-item-price .jsc-variant-price .theme-money').text(currency_varPrice);
  }
  
  //console.log('currency_varPrice',currency_varPrice);
  for (var j = 0; j < $itemVarOpt.length; j++) {
    var $itemVarTitle = $itemVarOpt[j].name + ': ' + $itemVarOpt[j].value;

    $cloneGrid.find('.cart-line-item-prod-var-title').append('<div class="cart-line-item-var-title">' + $itemVarTitle + '</div>');
  }
  $cloneGrid.removeClass('d-none').removeClass('jsc-dummy-cart-line-items');
  //$cloneGrid.appendTo('.jsc-cart-items-section');
  $cloneGrid.insertAfter('.jsc-dummy-cart-line-items.jsc-cart-line-items');
  jscOpenCartDrawer();
}
//end: side cart drawer

//start: calculate free shipping
calculateProgress = (currentVal, targetVal) => {

  var freeDeliverySection = $('.jsc-cart-freedelivery-section')
  var cartMinText = freeDeliverySection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeDeliverySection.find('.cart-shippingThreshold__progress');
  var progressNum = freeDeliverySection.find('.cart-shipping__num');
  var progressOuter = freeDeliverySection.find('.cart-shipping__numOuter');
  var successMsg = freeDeliverySection.find('.cart-shipping__success');

  if (freeDeliverySection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var _totalPrice = cart.total_price;
      
      if (_totalPrice > 0) {
        freeDeliverySection.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';
        //console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

        progressBar.each(function(){
          
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          console.log('free delivery');
          progressOuter.hide();
          successMsg.show();
        } else {
          console.log('still short from free delivery',calcFreeDeliveryVal);
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
        }
      }
      else{
        //console.log('cart Total',_totalPrice);
        freeDeliverySection.addClass('d-none');
      }
      
    })).then(function() {
      
    });
  }
};
//end: calculate free shipping
fetch('/cart.js')
.then(response => response.json())
.then(data => {
  var _sgMinPrice = parseInt($('.jsc-cart-freedelivery-section .cart-shipping__wrapper').attr('minprice-aud'));
  var _gwpMinPrice = parseInt($('.jsc-cart-freegift-section .cart-shipping__wrapper').attr('minprice-aud'));
  //calculateProgress(data.total_price, _sgMinPrice);
  //calculateProgressGWP(data.total_price, _gwpMinPrice);
});
//end: calculate free shipping

//start: cart drawer qty selector
jscMinusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var count = parseInt($input.val()) - 1;
  var $maxQty = parseInt($(e).parents('.jsc-cart-line-items').find('.jsc-product-details-input').attr('data-max-qty'));
  var $thisPlus = $(e).parent().find('.plus');
  count = count < 1 ? 1 : count;
  //$input.val(count);
  $input.attr('value',count);
  $input.change();

  var $vid = $(e).parents('.jsc-cart-line-items').attr('data-var-id');
  if (count >= 1) {
    //console.log('enable minus');
    $(e).removeClass('unusable');
    cartJSUpdateQuery($vid, count, {}, true);
    
  } 
  if (count == 1) {
    //console.log('disable minus');
    $(e).addClass('unusable');
  }
  
  jscUpdateCartDrawer();
  if ($input.val() < $maxQty ) {
    $thisPlus.removeClass('unusable'); // allow to add more product
  }
}
jscPlusItemCartDrawer = (e) => {
  var $input = $(e).parent().find('input');
  var $thisMinus = $(e).parent().find('.minus');
  var $maxQty = parseInt($(e).parents('.jsc-cart-line-items').find('.jsc-product-details-input').attr('data-max-qty'));
  var $inputValueInt = parseInt($input.val());

  //console.log('current value',$inputValueInt,'$maxQty',$maxQty);
  if ($inputValueInt < $maxQty ) {
    //console.log('allow add');
    var count = parseInt($input.val()) + 1;
    //console.log('added',count);
    $input.attr('value',count);
    //$input.change();
    $thisMinus.removeClass('unusable'); // allow to add more product

    var $vid = $(e).parents('.jsc-cart-line-items').attr('data-var-id');
    
    cartJSUpdateQuery($vid, count, {}, true);
    jscUpdateCartDrawer();
    if ($input.val() >= $maxQty) {
      $(e).addClass('unusable'); // dont allow to add more product
      //console.log('dont allow add');
    }
  } 
}
jscRemoveItemCartDrawer = (e) => {
  var $vid = $(e).parents('.jsc-cart-line-items').attr('data-var-id');
  cartJSUpdateQuery($vid, 0, {}, true);
  $(e).parents('.jsc-cart-line-items').remove();

  var $isGwp = $(e).parents('.jsc-cart-line-items').attr('data-gwp');
  if ($isGwp == 'true') {
    sessionStorage.setItem("FreeGift", "Remove");
  }

  setTimeout(function(){
    jscUpdateCartDrawer('',true);
  },500);

}
//end: side cart drawer

//start: calculate free gift GWP progress bar
calculateProgressGWP = (currentVal, targetVal) => {
  var freeGiftSection = $('.jsc-cart-freegift-section');
  var cartMinText = freeGiftSection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeGiftSection.find('.cart-shippingThreshold__progress');
  var progressNum = freeGiftSection.find('.cart-shipping__num');
  var progressOuter = freeGiftSection.find('.cart-shipping__numOuter');
  var successMsg = freeGiftSection.find('.cart-shipping__success');
  var freeItemId = freeGiftSection.find('.cart-shipping__wrapper').attr('data-item-id');
  var isGwpInCart = false;

  if (freeGiftSection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var _totalPrice = cart.total_price;
      var $cartItems = cart.items;

      for (var i = 0; i < $cartItems.length; i++) {
        var $itemID = $cartItems[i].id;
        var $itemGwpProp = $cartItems[i].properties['_Cart_GWP'];
        var $itemGwpPropPromo = $cartItems[i].properties['_Cart_Gift'];

        if (freeItemId == $itemID && $itemGwpProp == 'Free Gift' && $itemGwpPropPromo == 1) {
          isGwpInCart = true;
          
        }
      }
      console.log('isGwpInCart',isGwpInCart);
      
      if (_totalPrice > 0) {
        freeGiftSection.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';
        //console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

        progressBar.each(function(){
          
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          console.log('free gift');
          progressOuter.hide();
          successMsg.show();
          if (isGwpInCart == false) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift" data-promo="1">');
            cartGift();
            jscUpdateCartDrawer(freeItemId,isGwpInCart);
          } else {
            $('.jsc-cart-items-section .jsc-cart-gift').remove();
          }
          
        } else {
          console.log('still short from free gift',calcFreeDeliveryVal);
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
          if (isGwpInCart == true) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift-remove jsc-promo-1">');
            //isGwpInCart = false;
            cartGift();
            jscUpdateCartDrawer(freeItemId,isGwpInCart);
          }
        }
      }
      else{
        //console.log('cart Total',_totalPrice);
        freeGiftSection.addClass('d-none');
      }
      
    })).then(function() {
    });
  }
};
jscUpdateShippingAndGWPbar = () => {
  setTimeout(function(){
    calculateProgress();
    calculateProgressGWP();
  },500);
}
//end: calculate free gift GWP progress bar